import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Mitgliedschaft', path: '/membership' },
    { name: 'Kurse', path: '/classes' },
    { name: 'Personal Training', path: '/personal-training' },
    { name: 'Spa', path: '/spa' },
    { name: 'Über uns', path: '/about' },
    { name: 'Kontakt', path: '/contact' },
  ];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-sm' : 'bg-transparent'
      }`}>
        <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-12">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <Link to="/" className="hover:opacity-80 transition-opacity mt-6 sm:mt-8 lg:mt-12">
              <img src="/images/positiv-logo.png" alt="POSITIV Logo" className="h-10 sm:h-14 lg:h-20" />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-white text-lg font-medium tracking-wide hover:opacity-70 transition-opacity ${
                    location.pathname === link.path ? 'opacity-100' : 'opacity-90'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="hidden lg:flex items-center gap-4">
              <Button
                variant="outline"
                className="bg-transparent text-white border-white hover:bg-white hover:text-black px-6 h-11"
                asChild
              >
                <Link to="/membership">Jetzt Mitglied werden</Link>
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-white p-2"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black lg:hidden pt-16">
          <div className="flex flex-col p-6 space-y-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-white text-lg font-medium tracking-wide hover:opacity-70 transition-opacity"
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-6 space-y-4">
              <Button
                className="w-full bg-white text-black hover:bg-white/90 h-12"
                asChild
              >
                <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Club besuchen</Link>
              </Button>
              <Button
                variant="outline"
                className="w-full bg-transparent text-white border-white hover:bg-white hover:text-black h-12"
                asChild
              >
                <Link to="/membership" onClick={() => setIsMobileMenuOpen(false)}>Jetzt Mitglied werden</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
